import React from "react";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { RegisterForm } from "@/components/auth/RegisterForm";
import { useTranslation } from "@/lib/i18n";
export default function RegisterPage() {
  const { t } = useTranslation();
  return (
    <AuthLayout title={t('register_title')} subtitle={t('register_subtitle')}>
      <RegisterForm />
    </AuthLayout>
  );
}